export default "__VITE_ASSET__CDKiQMWN__"